/**
 * Locked WeUpsell brand attribution (footer) for catalog upsell layouts.
 * Merchants cannot edit copy or link — visibility follows shop watermark flags.
 */

export const BRAND_ATTRIBUTION_LINK_URL =
  "https://apps.shopify.com/ai-upsell-cross-sell-by-weupsell";

export const DEFAULT_BRAND_ATTRIBUTION_DISPLAY = {
  prefix: "Powered by",
  linkText: "WeUpsell",
  linkUrl: BRAND_ATTRIBUTION_LINK_URL,
  suffix: "",
  showBrandBadge: false,
  badgeText: "WeUpsell",
  badgeShowLogo: true,
};

/** @param {object | null | undefined} section */
export function getBrandAttributionDisplay(section) {
  const display = section?.setting?.display;
  const merged = {
    ...DEFAULT_BRAND_ATTRIBUTION_DISPLAY,
    ...(display && typeof display === "object" ? display : {}),
  };
  // Locked branding: always use canonical copy + App Store link (ignore stale saved text).
  merged.prefix = DEFAULT_BRAND_ATTRIBUTION_DISPLAY.prefix;
  merged.linkText = DEFAULT_BRAND_ATTRIBUTION_DISPLAY.linkText;
  merged.suffix = DEFAULT_BRAND_ATTRIBUTION_DISPLAY.suffix;
  merged.linkUrl = BRAND_ATTRIBUTION_LINK_URL;
  return merged;
}

export function isBrandAttributionLocked(section) {
  return (
    section?.type === "BRAND_ATTRIBUTION" ||
    section?.setting?.locked === true ||
    section?.setting?.role === "brandAttribution"
  );
}
